import React, { useEffect, useState } from "react";
import { Input, Checkbox, Button, Space, Row, Col, List, Modal, Image, Alert, Tooltip, Empty } from "antd";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { PropertyHandlers } from "../state/actions";
import axios from "axios";
import { Loading } from "../../Common";
import { useMediaQuery } from "react-responsive";
import moment from "moment";
import ResureSign from "../../Assets/Icons/Resure_icon.png";
import { FileTextOutlined } from "@ant-design/icons";
import OtherDocsTable from "../../Tools/components/OtherDocsTable";

const ReSureSignDocs = ({handleCancel, handleAddListingDocsAndReSureDocs, handlePropertyDocs, selectedItems, handleCheckboxChange, checkedDocs, setCheckedDocs, nestedModalOpen, setNestedModalOpen, propertyId, offerId, RTDInitiator, buyerAgentIds, sellerAgentIds, isWeb, delegate }) => {
  
  const dispatch = useDispatch();
  let { resure_Sign_Loading, resure_Sign_Docs ,importResureSignSucess} = useSelector((state) => state.PropertyReducer, shallowEqual);
  

  const isSmallScreen = useMediaQuery({ maxWidth: 600 });
  const isMediumScreen = useMediaQuery({ maxWidth: 800, minWidth: 601 });

  let unmounted = {
    value: false,
  };
  let source = axios.CancelToken.source();


  useEffect(() => {
    let delegateOwnerId =  delegate?.delegateOwnerId || null;
    dispatch(PropertyHandlers.getResure_SignDocs({delegateOwnerId}));
    return () => {
      unmounted.value = true;
      source.cancel("Cancelling in cleanup");
    };
  }, []);

 

  // const handleImport = () => {
  //   Modal.confirm({
  //     title: "Would you like to copy these documents to Property Docs?",

  //     okText: "Yes",
  //     cancelText: "No",
  //     onOk: async () => {
  //       const formIds = checkedDocs.map((doc) => doc._id);
  //       const importPayload = {
  //         formIds,
  //         ...(offerId ? { offerId } : {}),
  //         ...(propertyId ? { propertyId } : {}),
  //         RTDInitiator,
  //         ...(buyerAgentIds && buyerAgentIds.length > 0 ? { buyerAgentIds } : {}),
  //         ...(sellerAgentIds && sellerAgentIds.length > 0 ? { sellerAgentIds } : {})
  //       };

  //       await dispatch(PropertyHandlers.importRe_sure_sign_docs(importPayload));
  //       handleCancel();
  //       const params = {
  //         ...(offerId ? { offerId: offerId } : {}),
  //         ...(propertyId ? { propertyId: propertyId } : {}),
  //         openFor: RTDInitiator === "SELLER" ? "SELLER_AGENT" : "BUYER_AGENT",
  //         ...(delegate ? delegate : {}),
  //         section: "PROPERTY_DOCS",
  //         ...(isWeb ? { isWeb: true } : {}),
  //         queryPlatform: "WEB",
  //       };
        
  //       if ((offerId || propertyId)) {
  //         dispatch(PropertyHandlers.getPropertyDocsFun({ params, unmounted, source }));
  //       }
  //       // Your import logic here
  //     },
  //   });
  // };

  

  // const handleSingleCheck = (isChecked, doc) => {
  //   if (isChecked) {
  //     // Add full doc object if not already in checkedDocs
  //     setCheckedDocs((prev) => {
  //       const exists = prev.some((d) => d._id === doc._id);
  //       if (!exists) {
  //         return [...prev, doc];
  //       }
  //       return prev;
  //     });
  //   } else {
  //     // Remove the doc from checkedDocs
  //     setCheckedDocs((prev) => prev.filter((d) => d._id !== doc._id));
  //   }
  // };

  // const isChecked = (doc) => {
  //   return checkedDocs.some((d) => d._id === doc._id);
  // };

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
      {(resure_Sign_Docs?.length > 0) ? <div id="showMsgDiv" style={{ textAlign: "left" }}>
        <Alert style={{ width: "100%", fontSize: isSmallScreen ? '10px' : '12px'}} message={" When importing documents, a new copy of the selected document will be created. This copy will be visible under Property Documents and in RE-Sure Sign Documents. When accessed from RE-Sure, the imported document will be in PDF format. To send the document for signature or edit it, the author must log in to their RE-Sure Sign account."} type="info" showIcon />
      </div> : ""}
      {resure_Sign_Loading ? <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "50vh" }}><Loading /></div> : 
      (resure_Sign_Docs?.length > 0) ?
        <div>
          <div style={{ height: (isSmallScreen || isMediumScreen) ? '47vh' : '52vh', overflowY: "auto" }}>
            <OtherDocsTable handleOpenDoc={handlePropertyDocs} origin={"PROPERTY_DOCS_RE_SURE_SIGN"} handleCheckboxChange={handleCheckboxChange} selectedItems={selectedItems} reSureSignDocs={resure_Sign_Docs} />
          </div>
          <Button type="primary" onClick={() => handleAddListingDocsAndReSureDocs({origin: 'PROPERTY_DOCS_RE_SURE_SIGN'})} style={{ marginTop: "20px" }} disabled={!selectedItems?.length}>
            Done
          </Button>
        </div> : 
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "50vh" }}>
            <Empty />
          </div>
        }
    </div>
  )
};

export {ReSureSignDocs};